import { UrlMatchResult, UrlSegment } from '@angular/router';

export function recipeDetailsMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length >= 1 && segments[0].path === 'recipe') {
    return { consumed: segments.slice(0, 1) };
  }
  if (segments.length >= 2 && segments[1].path === 'recipe') {
    return { consumed: segments.slice(0, 2) };
  }
  return null;
}
